import { getAppInstance } from '@/utils/api/app';
import { Channels } from '@/components/Calculator/types';
import { RepresentativeAprResponse } from './getRepresentativeApr';

export type PricingResponse = {
  pricingData: PricingData;
};

interface PricingData extends RepresentativeAprResponse {
  repPrice: {
    monthlyPayment: number;
    totalInterest: number;
    interestRate: number;
    totalCredit: number;
    totalCost: number;
    years: number;
    loan: number;
    apr: number;
    fee: number;
  };
  pricing: {
    [key: string]: {
      min_apr: number;
      min_pmt: number;
    };
  };
  channelCode: string;
  lastUpdate: string;
  lastCheck: string;
  specName: string;
  maxApr: number;
  minApr: number;
  hash: string;
}

export const getPricingData = ({ channel }: Record<'channel', Channels>) =>
  getAppInstance().get<PricingResponse>(`/pricing?channel=${channel}`);
